function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Search({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.449 1c5.21 0 9.448 4.239 9.448 9.449 0 2.355-.866 4.51-2.295 6.167l3.804 3.806a.999.999 0 11-1.414 1.414l-3.85-3.851a9.4 9.4 0 01-5.693 1.912C6.239 19.897 2 15.659 2 10.449S6.239 1 11.449 1zm0 2C7.342 3 4 6.342 4 10.449c0 4.108 3.342 7.448 7.449 7.448 4.107 0 7.448-3.34 7.448-7.448C18.897 6.342 15.556 3 11.449 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoSearch = React.memo(Search);
export default MemoSearch;